<h1 *ngIf="title" mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <div *ngIf="isHtml" [innerHTML]="safeHtmlMessage"></div>
  <div *ngIf="!isHtml">{{ message }}</div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{ 'No' | translate }}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ 'Yes' | translate }}</button>
</div>
